import {ScaffoldSubmission} from '../component/renter-home/renterHomeUtils'

export type FoundPlaceOutcomeType = 'submitted_property' | 'elsewhere' | 'not_found'

export type FoundPlaceConfirmationRequest = {
  outcomeType: FoundPlaceOutcomeType
  submissionId: string | null
}

export const isLiveOutcomeSubmission = (submission: ScaffoldSubmission): boolean =>
  submission.canSelectForFoundPlace === true &&
  submission.status !== 'revoked' &&
  submission.status !== 'expired' &&
  !submission.revokedAt &&
  (!submission.expiresAt || new Date(submission.expiresAt).getTime() > Date.now())
